import React, { useState, useEffect } from 'react'
import Breadcrumb from '../../../components/partials/Breadcrumb';
import { BiCategory } from "react-icons/bi";
import { FaSearch } from 'react-icons/fa';
import { Alerts, GetProducts } from '../../../helpers';
import MUIDataTable from "mui-datatables";
import { Link } from 'react-router-dom';
import { FaEdit, FaTimes, FaPlus, FaQuestion, FaFileExport, FaFileImport } from "react-icons/fa";
import ConfirmationDialog from '../../../components/cmp/ConfirmationDialog';
import ConfModal from '../../../components/cmp/ConfModal';
import { Spinner } from 'react-bootstrap';
import MyModal from '../../../components/cmp/MyModal';
import axios from 'axios';
import { Apis } from '../../../config';
import ThemeModal from '../../../components/cmp/ThemeModal';
import EditProductVariation from '../../../components/product/EditProductVariation';

const Products = () => {
  const [isLoading, setLoading] = useState(true);
  const [arrData, setData] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [delId, setDelId] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [editableVariations, setEditableVariations] = useState({});
  const [expandedRows, setExpandedRows] = useState([]);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [isEditVariations, setEditVariations] = useState(false);

  const [isSingleVartion, setSingleVariation] = useState(false);
  const [currentVariation, setCurrentVar] = useState(null);

  const handleOpenVariation = (variation) =>{
    console.log(variation);
     setSingleVariation(true);
     setCurrentVar(variation);
  }

    const handleCloseVariation = () =>{
     setSingleVariation(false);
     setCurrentVar(null);
  }

   

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [productStatus, setProductStatus] = useState('');


  const getData = async () => {
    setLoading(true)
    let resp = await GetProducts.getAllProducts({
      page: page + 1,
      limit: rowsPerPage,
      search: searchText || '',
      productStatus: productStatus
    });
    if (resp && resp.status) {
      setData(resp.data);
      setTotalCount(resp.totalProducts || 0);
      setLoading(false);
    } else {
      setData([]);
      setTotalCount(0);
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, searchText, productStatus])

  

  const handleVariationUpdate = (productId, variationId, updatedVariation) => {
    setData(prevData =>
    prevData.map(product => {
      if (product.id === productId) {
        return {
          ...product,
          product_variations: product.product_variations.map(v =>
            v.id === variationId ? { ...v, ...updatedVariation } : v
          )
        };
      }
      return product;
    })
  );

  setSingleVariation(false);
  setCurrentVar(null);
};


    const deleteVariation = async (delIds) => {
         const {variationId, productId} = delIds;
         const resp = await GetProducts.deleteProductVariation(variationId);
         if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setData(prevData =>
              prevData.map(product => {
             if (product.id === productId) {
              return {
               ...product,
              product_variations: product.product_variations.filter(v => v.id !== variationId)
             };
           }
           return product;
          })
         );
         } else {
            Alerts.alertMessage('Something went wrong.', 'top-right', 'error')
         }
    }


  const handleInputChange = (productId, variationId, field, value) => {
    setEditableVariations(prev => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        [variationId]: {
          ...((prev[productId] && prev[productId][variationId]) || {}),
          [field]: value
        }
      }
    }));
  };
  const handleBulkSave = async (productId) => {
    setUpdateLoading(true);
    const variations = editableVariations[productId];
    const resp = await GetProducts.updateProductVariations({ variations });
    if (resp && resp.status) {
      setUpdateLoading(false);
      Alerts.alertMessage(resp.message, "top-right", "success");
    } else {
      setUpdateLoading(false);
      Alerts.alertMessage(resp.message, "top-right", "error");
    }
  };



  const options = {
    serverSide: true,
    count: totalCount,
    page: page,
    rowsPerPage: rowsPerPage,
    filter: false,
    download: false,
    print: false,
    selectableRows: false,
    expandableRows: true,
    search: true,
    rowsExpanded: expandedRows,
    onRowExpansionChange: (curExpanded, allExpanded) => {
      setExpandedRows(allExpanded.map(row => row.dataIndex));
    },
    onTableChange: (action, tableState) => {
      if (action === 'changePage') {
        setPage(tableState.page);
      } else if (action === 'changeRowsPerPage') {
        setRowsPerPage(tableState.rowsPerPage);
        setPage(0);
      }
    },
    renderExpandableRow: (rowData, rowMeta) => {
      const product = arrData[rowMeta.dataIndex];
      const productId = product.id;

      if (!product.product_variations || product.product_variations.length === 0) return null;


      return (
        <tr>
          <td colSpan={12}>
            <div style={{ display: 'flex', alignItems: 'center', gap: "5px" }}>
              <h5 style={{ fontSize: 16, marginTop: 10, marginBottom: 10 }}>Variations ({product.product_variations.length})</h5>
              <div className='d-flex align-items-center gap-1'>
                {
                  isEditVariations && <button className='btn btn-success btn-sm' onClick={() => handleBulkSave(productId)} disabled={updateLoading} style={{ marginRight: 5, marginLeft:20 }}>
                    {updateLoading ? 'Processing' : 'Save'}
                  </button>
                }
                <button className='btn btn-sm d-flex align-items-center gap-1' onClick={() => setEditVariations(!isEditVariations)}><FaEdit size={14} /> Edit</button>
              </div>

            </div>
            <table className="table table-bordered ft-12">
              <thead className="thead-light">
                <tr style={{ backgroundColor: '#e5e5e5e5' }}>
                  <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>ID</th>
                  <th style={{ textAlign: 'center', fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Thumbnail</th>
                  <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>SKU</th>
                  <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Title</th>
                  <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Sale Price</th>
                  <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Regular Price</th>
                  <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Stock</th>
                  <th style={{ fontWeight: 500, backgroundColor: '#e5e5e5e5' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {product.product_variations.map((variation, index) => {
                  const variationId = variation.id;
                  let variationImage = product.variation_image ? variation.variation_galleries ? variation.variation_galleries.length ? variation.variation_galleries[0].media_file.path : '' : '' : product.product_thumbnail?.path;
                  const localData = editableVariations?.[productId]?.[variationId] || {};
                  return <tr key={index}>
                    <td>{variationId}</td>
                    <td style={{ textAlign: 'center' }}><img src={variationImage} alt='img' width={50} /></td>
                    <td style={{ maxWidth: 200 }}>{variation.sku}</td>
                    <td style={{ maxWidth: 200 }}>{variation.variation_content?.title}</td>
                    <td>
                      {
                        isEditVariations ?
                          <div class="input-group mb-3">
                            <div class="input-group-prepend" style={{ height: 30 }}>
                              <span class="input-group-text" style={{ height: 31, borderRadius: 0 }}>£</span>
                            </div>
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              value={localData.sale_price ?? variation.sale_price}
                              onChange={(e) => handleInputChange(productId, variationId, 'sale_price', e.target.value)}
                              style={{ maxWidth: 90, height: 30 }}
                            />
                          </div>
                          : `£ ${localData.sale_price || variation.sale_price}`
                      }


                    </td>
                    <td>
                      {
                        isEditVariations ?
                          <div class="input-group mb-3">
                            <div class="input-group-prepend" style={{ height: 30 }}>
                              <span class="input-group-text" style={{ height: 31, borderRadius: 0 }}>£</span>
                            </div>
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              value={localData.regular_price ?? variation.regular_price}
                              onChange={(e) => handleInputChange(productId, variationId, 'regular_price', e.target.value)}
                              style={{ maxWidth: 90, height: 30 }}
                            />
                          </div>

                          : `£ ${localData.regular_price || variation.regular_price}`
                      }
                    </td>
                    <td>
                      {
                        isEditVariations ?
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={localData.stock ?? variation.stock}
                            style={{ maxWidth: 90 }}
                            onChange={(e) => handleInputChange(productId, variationId, 'stock', e.target.value)}
                          /> : `${localData.stock || variation.stock}`
                      }
                    </td>
                     <td>
                      {
                      <div className={`actions`} >
                         <button className="btn btn-info btn-sm" onClick={()=>handleOpenVariation(variation)}>
                            <FaEdit size={14} />
                          </button>
                       { currentVariation && currentVariation.id === variationId && <EditProductVariation isSingleVartion={isSingleVartion} handleCloseVariation={handleCloseVariation} variation={currentVariation} productId={productId}  onVariationUpdated={(updatedVariation) => handleVariationUpdate(productId, variationId, updatedVariation)}/>}
                      | <ConfModal message={'Are you sure you want to delete this record'} delId={{variationId:variationId, productId:productId}} handleDelete={deleteVariation} />
                      
                   
                    </div>
                      }
                    </td>

                  </tr>
                }
                )}
              </tbody>
            </table>
          </td>
        </tr>
      );
    }
  };



  const columns = [
    {
      name: 'SL'
    },
    {
      name: 'sku',
      label: 'SKU',
      options: {
        searchable: true,
        sort: false,
        customHeadRender: () => <div>&nbsp;</div>,
        customBodyRender: (value) => (
          <div style={{ display: 'none' }}>{value}</div> // ✅ Visually hidden
        ),
        customSearch: (searchQuery, currentValue) => {
          if (!searchQuery || !currentValue) return false;

          const skus = currentValue.split(',').map(s => s.trim().toLowerCase());
          return skus.some(sku => sku.includes(searchQuery.toLowerCase()));
        }
      }
    },

    {
      name: 'id',
      sortable: false,
    },
    {
      name: 'Title',
      sortable: true,
    },
    {
      name: 'Category',
      sortable: true,
    },
    {
      name: 'Thumbnail',
    },
    {
      name: 'Price',
      sortable: true,
    },

    {
      name: 'Status',
      sortable: true,
    },
    {
      name: 'Actions',
      sortable: false,
    },
  ];

  const deleteRecord = async (id) => {

    let resp = await GetProducts.deleteProductWithDetails(id);
    if (resp && resp.status) {
      Alerts.alertMessage(resp.message, 'top-right', 'success');
      getData();
    } else {
      Alerts.alertMessage(resp.message, 'top-right', 'error');
    }
    setDelId(null);
    setShowDialog(false);
  }

  const showDialogBox = (id) => {
    setDelId(id);
    setShowDialog(true);
  }

  const variationPrices = (arrayData) => {
    const salePrices = arrayData.map((product) => parseFloat(product.sale_price));
    const minSalePrice = Math.min(...salePrices);
    const maxSalePrice = Math.max(...salePrices);
    return `£${minSalePrice} - £${maxSalePrice}`;
  }



  const handleExportReady = async () => {
    setExportLoading(true);
    const resp = await GetProducts.exportProductProcess();
    if (resp && resp.status) {
      setExportLoading(false);
      setShowExportModal(true);
    }
  }

  const handleDownload = async () => {
    try {
      setDownloadLoading(true);
      var token = localStorage.getItem('userToken');
      const response = await axios.get(Apis.DownloadExportedProduct, {
        responseType: 'blob',
        headers: {
          'x-access-token': token,
        },
      });

      if (response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'products_export.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        setDownloadLoading(false);
        setShowExportModal(false);
      }

    } catch (err) {
      console.error('Download failed:', err);
    }
  };

  const handleSearch = () => {
    setPage(0);
    setSearchText(searchInput.trim());
  };


  return (
    <>
      {/* <Breadcrumb breadcrumbs={breadcrumbs} /> */}
      <div className="innerPageWrapper">
        <div className='container-fluid'>
          <div className='page-title'>
            <h2><BiCategory /> Products</h2>
            <div className='media-actions'>
              <Link to="/app/import/products" className="btn btn-default btn-sm d-flex align-items-center gap-1">
                <FaFileImport style={{fontSize:14}} /> Import</Link>
              <button type='button' className="btn btn-primary btn-sm d-flex align-items-center gap-1" onClick={handleExportReady}> {exportLoading ? <><Spinner animation="border" size='sm' /> Processing..</> : <>
                <FaFileExport style={{fontSize:14}}/>
                Export</>}</button>
              <Link to="/app/product/create" className="btn btn-success btn-sm d-flex align-items-center gap-1"><FaPlus style={{fontSize:14}}/> Add New</Link>
            </div>
          </div>
          <div className="filter-box mb-3 d-flex gap-3 align-items-center flex-wrap justify-content-between">
            <div class="btn-group" className='product-filter'>
              <button type="button" class={`btn btn-default ${productStatus === "" ? 'active' : ''}`} onClick={() => setProductStatus('')}>All</button>
              <button type="button" class={`btn btn-default ${productStatus === 1 ? 'active' : ''}`} onClick={() => setProductStatus(1)}>Active</button>
              <button type="button" class={`btn btn-default ${productStatus === 0 ? 'active' : ''}`} onClick={() => setProductStatus(0)}>Draft</button>
            </div>
            <div className="searchInput">
              <div class="input-group">
                <input type="text"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  class="form-control"
                  placeholder="Search by title or category" />
                <button class="btn btn-outline-secondary" type="button" onClick={handleSearch}><FaSearch /></button>
              </div>
            </div>
          </div>

          {
            isLoading ? <div className='loader'>
              <img src='/images/loader.gif' alt='loader' />
            </div> : <>
              <MUIDataTable
                title=""
                className="hideHeader"
                data={arrData.map((item, i) => {
                  const sku = item.isVariation
                    ? item.product_variations.map(v => v.sku).join(', ')
                    : item.sku;

                  return [
                    ++i,
                    sku,
                    item.id,
                    <div style={{ minWidth: 200, wordBreak: 'break-all' }}>
                      {item.title}
                    </div>
                    ,
                    item.categories.length > 0 && item.categories.map(el => {
                      return `${el.title},`;
                    }),
                    <img src={item.product_thumbnail?.path} alt="thumbnail" width="60px" />,
                    <div style={{ width: 120 }}>{item.isVariation ? variationPrices(item.product_variations) : `£${item.sale_price}`}</div>,
                    // <div>£ {item.regular_price !== item.sale_price && <del>{item.regular_price} <br/></del> }  {item.sale_price}</div>,
                    <div className={`badge ${item.status ? "bg-success" : "bg-danger"}`}>{item.status ? 'Active' : 'Draft'}</div>,
                    <div className={`actions`} style={{ width: "170px" }}>
                      <Link to={`/app/products/manage/${item.id}`} className="btn btn-info btn-sm"><FaEdit /></Link> | <button onClick={() => showDialogBox(item.id)} className="btn btn-danger btn-sm"><FaTimes /></button>
                      |  <Link to={`/app/product/faqs/${item.id}`} className="btn btn-secondary btn-sm"><FaQuestion /></Link>
                      {/* |  <Link to={`/app/product/variation/${item.id}`} className="btn btn-success btn-sm"><MdSettings size={14} color='#fff'/></Link> */}
                    </div>
                  ]
                })}
                columns={columns}
                options={options}
              />
              {showDialog ? <ConfirmationDialog delId={delId} setShowDialog={setShowDialog} deleteRecord={deleteRecord} show={showDialog} message="Are you sure you want to delete this record." /> : null}

              {
                showExportModal ?
                  <MyModal show={showExportModal} title={'File ready to download'} size='md'>
                    <div className='text-center'>
                      <button className='btn btn-primary' onClick={handleDownload} disabled={downloadLoading}>
                        {downloadLoading ? <><Spinner animation="border" size='sm' /> Processing..</> : 'Download Now'}
                      </button>
                    </div>
                  </MyModal>
                  : null
              }

            
            </>
          }
        </div>
      </div>
    </>
  )
}

export default Products;